module.exports = __webpack_public_path__ + "img/bg25.e9bbdc66.jpeg";